import { render, staticRenderFns } from "./ReportsInventory.vue?vue&type=template&id=2887c8a0&scoped=true&"
import script from "./ReportsInventory.vue?vue&type=script&lang=js&"
export * from "./ReportsInventory.vue?vue&type=script&lang=js&"
import style0 from "./ReportsInventory.vue?vue&type=style&index=0&id=2887c8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2887c8a0",
  null
  
)

export default component.exports